<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('safe.language') }}
      </div>
    </div>
    <div class="wrap_box">
      <div
        class="item"
        @click="changeLang('en_us',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/en_us.png"></div>
          <div class="info">
            English
          </div>
        </div>
        <div v-if="lang=='en_us'">
          ✓
        </div>
      </div>
	  
      <div
        class="item"
        @click="changeLang('bg_bg',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/bg_bg.png"></div>
          <div class="info">
            български език
          </div>
        </div>
        <div v-if="lang=='bg_bg'">
          ✓
        </div>
      </div>
	 
      <div
        class="item"
        @click="changeLang('id_ind',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/id_ind.png"></div>
          <div class="info">
            Français
          </div>
        </div>
        <div v-if="lang=='id_ind'">
          ✓
        </div>
      </div>
      
      <div
        class="item"
        @click="changeLang('ms_my',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ms_my.png"></div>
          <div class="info">
            Español
          </div>
        </div>
        <div v-if="lang=='ms_my'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('th_th',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/th_th.png"></div>
          <div class="info">
            Deutsch
          </div>
        </div>
        <div v-if="lang=='th_th'">
          ✓
        </div>
      </div>
    
      <div
        class="item"
        @click="changeLang('vi_vn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/vi_vn.png"></div>
          <div class="info">
            Русский
          </div>
        </div>
        <div v-if="lang=='vi_vn'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('pt_br',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/pt_br.png"></div>
          <div class="info">
            Português
          </div>
        </div>
        <div v-if="lang=='pt_br'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('zh_hk',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_hk.png"></div>
          <div class="info">
            Italiano
          </div>
        </div>
        <div v-if="lang=='zh_hk'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('tr_tr',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/tr_tr.png"></div>
          <div class="info">
            Türkçe
          </div>
        </div>
        <div v-if="lang=='tr_tr'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('pl_pl',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/pl_pl.png"></div>
          <div class="info">
            język polski
          </div>
        </div>
        <div v-if="lang=='pl_pl'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('ro_ro',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ro_ro.png"></div>
          <div class="info">
            limba română
          </div>
        </div>
        <div v-if="lang=='ro_ro'">
          ✓
        </div>
      </div>
      <div
        class="item"
        @click="changeLang('ja_jp',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ja_jp.png"></div>
          <div class="info">
            日本語
          </div>
        </div>
        <div v-if="lang=='ja_jp'">
          ✓
        </div>
      </div>
      
      <div
        class="item"
        @click="changeLang('ko_kr',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/ko_kr.png"></div>
          <div class="info">
            한국인
          </div>
        </div>
        <div v-if="lang=='ko_kr'">
          ✓
        </div>
      </div>
     
      
      <div
        class="item"
        @click="changeLang('zh_cn',$event)"
      >
        <div class="left flex_center">
          <div><img src="../images/language/zh_cn.png"></div>
          <div class="info">
            中文繁体
          </div>
        </div>
        <div v-if="lang=='zh_cn'">
          ✓
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Toast
  } from 'vant'
  export default {
    name: "Language",
    data() {
      return {
        lang:this.$i18n.locale||"en_us",
      };
    },
    created() {
      this.$parent.footer('user', false);
    },
    mounted() {
    },
    methods: {
      changeLang(lang) {
        Toast.loading({
          // mask: true,
          duration: 200
        })
        this.lang = lang;
        this.$i18n.locale = lang;
        localStorage.setItem("lang", lang);
        this.$router.go(-1);
      },
    }
  };
</script>

<style lang="less" scoped>
  
  .wrap_box{
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0 0 5px 5px;
    .item{
      height: 50px;
      width: 95%;
      padding: 16px 0;
      border-bottom: 1px solid #ECECEC;
      font-size: 14px;
      color: rgba(0,0,0,.8);
      font-weight: bold;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      .right{
        width: 20px;
        height: 20px;
        background: url(../images/user/arrow.png) no-repeat center center;
        background-size: 100% 100%;
      }
      .right_info{
        color: rgba(0,0,0,.6);
      }
      .tips{
        color: rgba(0,0,0,.6);
        margin-left: auto;
        margin-right: 4px;
        font-weight: normal;
      }
      .left{
        img{
          width: 33px;
          margin-top: 5px;
        }
      }
    }
  }
  .info{
    margin-left: 10px;
  }

  .basic_wrap {
    min-height: 100vh;
    padding-bottom: 88px;
    box-sizing: border-box;
    background: #f4f5fb;
    color: #061429;
    font-size: 12px;
  }

  .red_top_bg {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 50px;
    background: #f7f8fd;
  }

  .big_tit {
    height: 50px;
    color: #202637;
    font-size: 14px;
    font-weight: 500;
    line-height: 50px;
    text-align: center;
  }

  .back_left {
    position: absolute;
    left: 14px;
    top: 11px;
    width: 28px;
    height: 28px;
    background: none;
  }

  .back_left::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 7px;
    width: 10px;
    height: 10px;
    border-left: 2px solid #071426;
    border-bottom: 2px solid #071426;
    transform: rotate(45deg);
  }

  .wrap_box {
    display: block;
    margin: 16px;
    padding: 0 14px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
  }

  .wrap_box .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 58px;
    padding: 0;
    box-sizing: border-box;
    border-color: #f0f2f7;
    color: #061429;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
  }

  .wrap_box .item:last-child {
    border-bottom: 0;
  }

  .wrap_box .item .left {
    display: flex;
    align-items: center;
    min-height: 58px;
    min-width: 0;
    line-height: 1;
  }

  .wrap_box .item .left > div:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
  }

  .wrap_box .item .left img {
    width: 30px;
    height: 30px;
    display: block;
    margin-top: 0;
    border-radius: 50%;
    box-shadow: 0 4px 10px rgba(30, 45, 82, .08);
  }

  .info {
    overflow: hidden;
    margin-left: 12px;
    color: #061429;
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wrap_box .item > div:not(.left) {
    position: relative;
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
    margin-left: 12px;
    color: transparent;
    font-size: 0;
    line-height: 1;
  }

  .wrap_box .item > div:not(.left)::before {
    content: '\2713';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: #ff1724;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
  }
</style>
